// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaginationMeta
 */
export interface PaginationMeta {
    /**
     * Total number of items
     */
    total: number;
    /**
     * Number of items skipped before the returned results
     */
    offset: number;
    /**
     * Maximum number of items returned
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginationMeta interface.
 */
export function instanceOfPaginationMeta(value: object): value is PaginationMeta {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginationMetaFromJSON(json: any): PaginationMeta {
    return PaginationMetaFromJSONTyped(json, false);
}

export function PaginationMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginationMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'offset': json['offset'],
        'limit': json['limit'],
    };
}

export function PaginationMetaToJSON(json: any): PaginationMeta {
    return PaginationMetaToJSONTyped(json, false);
}

export function PaginationMetaToJSONTyped(value?: PaginationMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'offset': value['offset'],
        'limit': value['limit'],
    };
}

